import { all } from "redux-saga/effects";
import rootResourceSaga from "../resource-user/redux/services";

export default function* rootSaga() {
    yield all([
        ...rootResourceSaga
    ]);
}
